export const environment = {
  production: false,
  baseUrl: 'https://moval.techkrate.in/backend/'
};